import type { StatusColorTone } from '@/styles/statusColors';

export const WORK_TYPE_TONE = {
  SD: 'success',
  MP: 'warning',
  TC: 'info',
  LC: 'neutral',
  OW: 'neutral',
  CSR: 'success',
} as const satisfies Record<string, StatusColorTone>;

export type WorkTypeCode = keyof typeof WORK_TYPE_TONE;

export function isWorkTypeCode(code: string): code is WorkTypeCode {
  return Object.hasOwn(WORK_TYPE_TONE, code);
}
